const LocationComponent = {
  IZVORISTE: { label: 'Izvorište', value: 0, layerName: 'Izvoriste' },
  BUNAR: { label: 'Bunar', value: 1, layerName: 'Bunar' },
  REZERVOAR: { label: 'Rezervoar', value: 2, layerName: 'Rezervoar' },
  PUMPNASTANICA: {
    label: 'Pumpna stanica',
    value: 3,
    layerName: 'Pumpna stanica',
  },
  TRANSPORTNICJEVOVOD: {
    label: 'Transportni cjevovod',
    value: 4,
    layerName: 'Transportni cjevovod',
  },
  DISTRIBUTIVNICJEVOVOD: {
    label: 'Distributivni cjevovod',
    value: 5,
    layerName: 'Distributivni cjevovod',
  },
  PRIKLJUCNICJEVOVOD: {
    label: 'Priključni cjevovod',
    value: 6,
    layerName: 'Prikljucni cjevovod',
  },
  ZATVARAC: { label: 'Zatvarač', value: 7, layerName: 'Zatvarac' },
  HIDRANT: { label: 'Hidrant', value: 8, layerName: 'Hidrant' },
  MULJNIISPUST: {
    label: 'Muljni ispust',
    value: 9,
    layerName: 'Muljni ispust',
  },
  ZRACNIVENTIL: {
    label: 'Zračni ventil',
    value: 10,
    layerName: 'Zracni ventil',
  },
  REDUCIRVENTIL: {
    label: 'Reducir ventil',
    value: 11,
    layerName: 'Reducir ventil',
  },
  MJERNOMJESTO: {
    label: 'Mjerno mjesto',
    value: 12,
    layerName: 'Mjerno Mjesto',
  },
  VODOMJERNOMJESTO: {
    label: 'Vodomjerno mjesto',
    value: 13,
    layerName: 'Vodomjerno mjesto',
  },
  OBJEKTIVODOVODA: {
    label: 'Objekti vodovoda',
    value: 14,
    layerName: 'Objekti vodovoda',
  },
  KANALIZACIONACIJEV: {
    label: 'Kanalizaciona cijev',
    value: 15,
    layerName: 'Kanalizaciona cijev',
  },
  KANALIZACIONISAHT: {
    label: 'Kanalizacioni šaht',
    value: 16,
    layerName: 'Kanalizacioni saht',
  },
  SLIVNICI: {
    label: 'Slivnici',
    value: 17,
    layerName: 'Slivnici',
  },
  NEPOZNATO: { label: 'Nepoznato', value: 18, layerName: 'Nepoznato' },
};

export default LocationComponent;
